module.exports = __webpack_public_path__ + "img/WA-New-Feature.168a4e9d.webp";